module.exports = __webpack_public_path__ + "img/icons_UI_chevron_right.3a6d7e7f.svg";